<template>
  <Transition name="fade">
    <div class="pop-bg" v-show="props.isShowRenew">

      <div class="pop-box newStyle">
        <p>{{ $t("续费") }}</p>
        <img src="../../assets/img/icons/icon-close.png" alt="" class="close" @click="emit('closeToast')">


        <div class="amend binding-tel">
          <common-select :name="$t('与真号码')" v-model="meetingCodeRenew" :options="state.allUniqueVirtualList"></common-select>
          <div class="code">
            <div class="row" style="margin-bottom: 0vw;">
              <p>
                {{ $t("截止时间") }}
              </p>
              <input type="text" v-model="state.deadlineRenew" disabled>
            </div>
          </div>
          <common-select :name="$t('续费期限')" v-model="durationCodeRenew" :options="state.durationList"></common-select>
          <div v-if="state.payFlag" style="display: flex;justify-content: center;align-items: center;">
            <div  class="next" @click="submitRenewOrder('alipay_pc')">{{ $t("支付宝") }}</div>
            <div  class="next" @click="submitRenewOrder('balance')">{{ $t("余额") }}￥{{ store.state.user.userInfo.account / 100 }}</div>
            <div  class="next" @click="submitRenewOrder('awardAccount')">{{ $t("Coin") }}￥{{ store.state.user.userInfo.awardAccount / 100 }}</div>
          </div>
        </div>
      </div>

    </div>
  </Transition>


</template>
<script setup>
import {getCurrentInstance, onMounted, reactive, ref, watch} from "vue";
import {ElMessage} from "element-plus";
import {
  createPackageRenewOrder,
  getPayOrder,
  submitOrder,
  userAccountPay,
  userAwardAccountPay
} from "@/api/yuzhen/order";
import {PayChannelEnum, PayDisplayModeEnum} from "@/utils/constants";
import {getAllUniqueVirtual} from "@/api/yuzhen/uniqueVirtual";
import {useStore} from "vuex";
import {pexipPackageArea} from "@/config/config";
import {getExclusivePackagePage} from "@/api/yuzhen/exclusivePackage";

// 多语言调用
const {appContext: {config: {globalProperties}}} = getCurrentInstance();
const props = defineProps(["isShowRenew"])
const emit = defineEmits(["closeToast"])
const store = useStore();
const state = reactive({
  durationList: [],
  durationMonthList: [
    {
      id: "100",
      txt: "1个月",
      count: 1,
    },
    {
      id: "101",
      txt: "3个月",
      count: 3,
    },
    {
      id: "102",
      txt: "6个月",
      count: 6,
    },
    {
      id: "103",
      txt: "12个月",
      count: 12,
    },
  ],
  durationYearList: [
    {
      id: "0",
      txt: "1年",
      count: 1,
    },
    {
      id: "1",
      txt: "2年",
      count: 2,
    },
    {
      id: "2",
      txt: "3年",
      count: 3,
    }
  ],
  payFlag: true,
  packageList: [], // 套餐列表
  deadlineRenew: '',
  allUniqueVirtualList: [],  // 续费选择使用，包括过期的与真号
  allUniqueVirtual: []
})


const meetingCodeRenew = ref(0)  //续费选择的与真号
const durationCodeRenew = ref(100)  //续费选择的期限
watch(meetingCodeRenew, (newVal, oldVal) => {
  var flag = false;
  // 是否存在套餐
  var packageFlag = false;
  state.durationList = []
  state.allUniqueVirtual.forEach(item => {

    if (item.id == meetingCodeRenew.value) {
      console.log(item)
      flag = true
      if (item.status == 1) {
        state.deadlineRenew = returnDate(item.endTime)
      }
      if(item.status == 2){
        state.deadlineRenew = globalProperties.$t('到期')
      }
      // 查找对应套餐
      state.packageList.forEach(packageItem => {

        if(item.packageId == packageItem.id){
          packageFlag = true
          // 可以支付
          state.payFlag = true
          if(packageItem.term == "365"){
            state.durationYearList.forEach(year =>{
              let yearItem
              yearItem = {
                id: year.id,
                txt: globalProperties.$t(year.txt) + "(￥" + packageItem.price / 100 * year.count + ")",
                count: year.count,
              }
              state.durationList.push(yearItem)
            })

          }
          if(packageItem.term == "30"){
            state.durationMonthList.forEach(month =>{
              let monthItem
              monthItem = {
                id: month.id,
                txt: globalProperties.$t(month.txt) + "(￥" + packageItem.price / 100 * month.count + ")",
                count: month.count,
              }
              state.durationList.push(monthItem)
            })
          }
        }
      })
    }
  })
  if(!flag){
    state.deadlineRenew = "";
  }
  // 套餐已经下架
  if(!packageFlag && newVal != 0){
    // 无法支付
    state.payFlag = false
    state.durationList.push({
      id: 0,
      txt: "该套餐已下架",
      count: 0,
    })
  }
})

function getPackage() {
  var query = {
    pageNo: 1,
    pageSize: 50,
    status: 0,
    area: pexipPackageArea,
  }
  getExclusivePackagePage(query).then(res => {
    console.log(res.data.list)
    state.packageList = res.data.list
  }).catch(err => {
    console.log(err)
  })
}



// 返回2023/08/31  类型日期
function returnDate(time) {
  let year = new Date(time).getFullYear()
  let month = new Date(time).getMonth() + 1 >= 10 ? new Date(time).getMonth() + 1 : "0" + (new Date(time)
      .getMonth() + 1)
  let date = new Date(time).getDate() >= 10 ? new Date(time).getDate() : "0" + new Date(time).getDate()
  return year + "/" + month + "/" + date
}

function submitRenewOrder(value){
  if(meetingCodeRenew.value == 0){
    ElMessage({
      type: 'error',
      message: globalProperties.$t('请选择虚拟会议号'),
    })
    return
  }

  var data = {
    uniqueVirtualId: meetingCodeRenew.value
  }
  state.durationList.forEach(item => {
    if(item.id == durationCodeRenew.value){
      data.count = item.count
      data.durationName = globalProperties.$t(item.txt)
    }
  })

  createPackageRenewOrder(data).then(res => {
    console.log(res)
    if(value == "alipay_pc"){
      let newWin = window.open();
      pay("alipay_pc",res.data.payOrderId,newWin)
    }
    if(value == "balance"){
      accountPayRenew(res.data.id)
    }
    if(value == "awardAccount"){
      awardAccountRenew(res.data.id)
    }

  }).catch(err => {

  })

}

let interval = undefined;
const accountFlag = ref(false);
function accountPayRenew(id){
  if(accountFlag.value){
    return;
  }
  accountFlag.value = true
  userAccountPay(id).then(res => {
    ElMessage({
      type: 'success',
      message: globalProperties.$t("余额支付成功"),
    })
    accountFlag.value = false
    emit('closeToast')
    // 更新用户余额
    store.dispatch("user/UpdateInfo").then(res=>{}).catch(err=>{})
  }).catch(err => {
    accountFlag.value = false
  })
}

const awardAccountFlag = ref(false);
function awardAccountRenew(id){
  if(awardAccountFlag.value){
    return;
  }
  awardAccountFlag.value = true
  userAwardAccountPay(id).then(res => {
    ElMessage({
      type: 'success',
      message: globalProperties.$t("与真Coin支付成功"),
    })
    awardAccountFlag.value = false
    emit('closeToast')
    // 更新用户余额
    store.dispatch("user/UpdateInfo").then(res=>{}).catch(err=>{})
  }).catch(err => {
    awardAccountFlag.value = false
  })
}

function pay(channelCode,orderId,newWin){

  //return;
  //isPaymentShow.value = false;
  //isPaymentResultShow.value = true;
  submitOrder({
    id: orderId,
    channelCode: channelCode,
    ...buildSubmitParam(channelCode)
  }).then(response => {
    const data = response.data
    if (data.displayMode === PayDisplayModeEnum.IFRAME.mode) {
      //this.displayIFrame(channelCode, data)
    } else if (data.displayMode === PayDisplayModeEnum.URL.mode) {
      displayUrl(channelCode, data,newWin)
    } else if (data.displayMode === PayDisplayModeEnum.FORM.mode) {
      document.write(data.displayContent);//自动提交表单数据
    } else if (data.displayMode === PayDisplayModeEnum.QR_CODE.mode) {
      //this.displayQrCode(channelCode, data)
    }

    // 打开轮询任务
    createQueryInterval()
  }).catch(() => {
    // this.submitLoading = false
  });
}

function buildSubmitParam(channelCode) {
  // ① 支付宝 PC 支付时，有多种展示形态
  if (channelCode === PayChannelEnum.ALIPAY_PC.code) {
    // 情况【前置模式】：将二维码前置到商户的订单确认页的模式。需要商户在自己的页面中以 iframe 方式请求支付宝页面。具体支持的枚举值有以下几种：
    // 0：订单码-简约前置模式，对应 iframe 宽度不能小于 600px，高度不能小于 300px
    // return {
    //   "channelExtras": {
    //     "qr_pay_mode": "0"
    //   }
    // }
    // 1：订单码-前置模式，对应iframe 宽度不能小于 300px，高度不能小于 600px
    // return {
    //   "channelExtras": {
    //     "qr_pay_mode": "1"
    //   }
    // }
    // 3：订单码-迷你前置模式，对应 iframe 宽度不能小于 75px，高度不能小于 75px
    // return {
    //   "channelExtras": {
    //     "qr_pay_mode": "3"
    //   }
    // }
    // 4：订单码-可定义宽度的嵌入式二维码，商户可根据需要设定二维码的大小
    // return {
    //   "channelExtras": {
    //     "qr_pay_mode": "4"
    //   }
    // }
    // 情况【跳转模式】：跳转模式下，用户的扫码界面是由支付宝生成的，不在商户的域名下。支持传入的枚举值有
    // return {
    //   "channelExtras": {
    //     "qr_pay_mode": "2"
    //   }
    // }
    // 情况【表单模式】：直接提交当前页面到支付宝
    return {
      displayMode: PayDisplayModeEnum.URL.mode
      //displayMode: PayDisplayModeEnum.FORM.mode
    }
  }

  // ② 支付宝 Wap 支付时，引导手机扫码支付
  if (channelCode === PayChannelEnum.ALIPAY_WAP.code) {
    return {
      displayMode: PayDisplayModeEnum.QR_CODE.mode
    }
  }

  // ③ 支付宝 BarCode 支付时，需要传递 authCode 条形码
  if (channelCode === PayChannelEnum.ALIPAY_BAR.code) {
    return {
      "channelExtras": {
        "auth_code": this.barCode.value
      }
    }
  }
  return {}
}

/** 提交支付后，URL 的展示形式 */
function displayUrl(channelCode, data,newWin) {
  newWin.location.href = data.displayContent;
  //window.open(data.displayContent)
  //let newWin = window.open();
  //newWin.document.body.innerHTML = data.displayContent;
  //newWin.document.querySelector('form[name="punchout_form"]').submit()
}

/** 轮询查询任务 */
function createQueryInterval() {
  if (interval) {
    return
  }
  interval = setInterval(() => {
    getPayOrder(orderId.value).then(response => {
      if (!response.data)
        return;
      // 已支付
      if (response.data.status == 2) {
        clearQueryInterval();
        ElMessage({
          type: 'success',
          message: globalProperties.$t("支付成功"),
        })
        emit('closeToast')
      }
      // 已取消
      if (response.data.status == 3) {
        clearQueryInterval();
        ElMessage({
          type: 'error',
          message: globalProperties.$t("支付取消"),
        })
      }
    }).catch(err => {
      console.log(err)
    })
  }, 1000 * 2)
}
/** 清空查询任务 */
function clearQueryInterval() {
  clearInterval(interval)
  interval = undefined
}

onMounted(() => {

  getAllUniqueVirtual().then(res => {
    state.allUniqueVirtualList.push({id:0,txt:globalProperties.$t("请选择")})
    res.data.forEach(item => {
      let txtName = item.virtualRoom
      if(item.status == 2){
        txtName += "(" + globalProperties.$t("到期") + ")"
      }
      state.allUniqueVirtualList.push({
        id: item.id,
        txt: txtName
      })
    })
    state.allUniqueVirtual = res.data
  }).catch(err => {})
  getPackage()
})
</script>
<style src="./meetingRenew.css" scoped>
</style>
